export default __webpack_public_path__ + "static/media/volodymyr-hryshchenko-e8YFkjN2CzY-unsplash.58811c2d.jpg";